import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Outlet, useLocation, Navigate } from "react-router-dom";

import Header from "./header";
import Sidebar from "./sidebar";
import Loader from "@/components/loader";

import useStore from "@/services/store";
import api from "@/services/api";
import { setUser, setApp } from "@/redux/auth/actions";

export function OnboardingLayout() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    try {
      const res = await api.get("/user/signin_token");
      if (!res.ok || !res.user) return setLoading(false);
      if (res.token) api.setToken(res.token);
      dispatch(setUser(res.user));
      dispatch(setApp(res.user.application || "waalego"));
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  }

  if (loading) return <Loader />;

  return <Outlet />;
}

export function Layout() {
  const { sideBarOpen } = useStore();
  const location = useLocation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const user = useSelector((state) => state.Auth.user);
  const redirect = encodeURIComponent(window.location.href.replace(window.location.origin, ""));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    try {
      const res = await api.get("/user/signin_token");
      if (!res.ok || !res.user) return setLoading(false);
      if (res.token) api.setToken(res.token);
      dispatch(setUser(res.user));
      dispatch(setApp(res.user.application || "finance"));
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  }

  if (loading) return <Loader />;
  if (!user) return <Navigate to={`/auth?redirect=${redirect}`} replace />;

  return (
    <div className="w-screen relative bg-white">
      <Sidebar />
      <div className={`${sideBarOpen ? "md:ml-64" : "ml-10"} flex flex-col ease-in-out duration-300`}>
        <Header />
        <main className="flex-1 overflow-x-auto bg-[#FBFBF9]">
          <div className="h-[calc(100vh-61px)] overflow-y-auto">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
